import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  TenantConnectionRequestDto,
  TenantConnectionRequestReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import TenantConnectionRequestInline, {
  TenantConnectionRequestInlineProps,
} from "./TenantConnectionRequestInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: TenantConnectionRequestDto | TenantConnectionRequestReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<TenantConnectionRequestInlineProps>;
}

export default function TenantConnectionRequestLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.TenantConnectionRead]}
      to={ROUTE_PATH.TENANT_CONNECTION_REQUEST_VIEW(entity?.id || entityId || "")}
      content={
        <TenantConnectionRequestInline entity={entity} entityId={entityId} {...inlineProps} />
      }
      {...otherProps}
    />
  );
}
